/** Map common markdown language shortcuts to lowlight languages */
export const lowlightLanguageMappings: Record<string, string> = {
  'ts': 'typescript',
  'js': 'javascript',
  'py': 'python',
  'py3': 'python',
  'c#': 'csharp',
  'c++': 'cpp',
  'node': 'javascript',
}

//
